import React, { useState } from 'react';

import SearchField from 'components/common/SearchField';
import useMartyContext from 'hooks/useMartyContext';

import css from 'styles/components/reviews/reviewSearch.scss';

interface Props {
  initialValue: string;
  searchReviews: (e: React.FormEvent<HTMLFormElement>, searchTerm: string) => void;
}

const ReviewSearch = ({ initialValue, searchReviews }: Props) => {
  const [value, setValue] = useState<null | string>(null);
  const { testId } = useMartyContext();

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    setValue(value);
  };

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    searchReviews(e, value === null ? initialValue : value);
  };
  return (
    <form method="get" className={css.form} role="search" aria-label="Review" onSubmit={onSubmit} data-test-id={testId('searchTermReviews')}>
      <SearchField
        name="searchTerm"
        id="reviewSearchField"
        type="search"
        placeholder="Search customer reviews"
        value={value !== null ? value : initialValue}
        onChange={onChange}
      />
      <label htmlFor="reviewSearchField" className="sr-only">
        Search Customer Reviews
      </label>
      <button type="submit" data-test-id={testId('searchReviewsButton')}>
        Search
      </button>
    </form>
  );
};

export default ReviewSearch;
